<template>
    <button
        type="button"
        class="ghost-button / flex"
        :disabled="props.disabled"
        :class="[`size-${props.size}`, {background, circle}]"
        @click="emit('click')"
    >
        <div>
            <slot />
        </div>
    </button>
</template>

<script setup lang="ts">
    import {computed} from 'vue';

    const props = withDefaults(
        defineProps<{
            disabled?: boolean;
            background?: boolean;
            size?: 's' | 'm' | 'l';
            circle?: boolean;
        }>(),
        {
            size: 's',
        },
    );

    const emit = defineEmits<{
        click: [];
    }>();

    const fontSize = computed(() => {
        if (props.size === 's') {
            return 'var(--joy-font-size-primary-200)';
        } else if (props.size === 'm') {
            return 'var(--joy-font-size-primary-300)';
        } else {
            return 'var(--joy-font-size-primary-400)';
        }
    });
</script>

<style lang="scss" scoped>
    button[type='button'].ghost-button {
        border-radius: var(--joy-core-radius-3);
        align-items: center;
        cursor: pointer;
        transition-property: transform, background-color;
        transition-duration: 0.2s;
        transition-timing-function: ease;
        font-size: v-bind(fontSize) !important;
        color: var(--joy-color-secondary-30);
        text-align: center;
        justify-content: center;
        flex: 0 0 auto;

        &.size {
            &-s {
                padding: var(--joy-core-spacing-1) var(--joy-core-spacing-2);

                &.circle {
                    padding: var(--joy-core-spacing-2);
                    width: 32px;
                    height: 32px;
                }
            }

            &-m {
                padding: var(--joy-core-spacing-2) var(--joy-core-spacing-3);

                &.circle {
                    padding: var(--joy-core-spacing-3);
                }
            }

            &-l {
                padding: var(--joy-core-spacing-2) var(--joy-core-spacing-3);
            }
        }

        &.circle {
            border-radius: var(--joy-core-radius-5);
        }

        &.background {
            background-color: var(--joy-color-neutral-20);

            &:hover:not(:disabled) {
                background-color: rgb(235 235 235);
            }
        }

        &:hover:not(:disabled) {
            background-color: var(--joy-color-neutral-20);
        }

        &:active:not(:disabled) {
            transform: scale(0.98);
        }

        &:disabled {
            cursor: not-allowed;
            color: var(--joy-color-neutral-40);
        }
    }
</style>
